import React, { useEffect, useRef, useState } from "react";

import "shaka-player/dist/controls.css";
import { useNotifications } from "../notifications/useNotifications";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const shaka = require("shaka-player/dist/shaka-player.ui.js");

export interface ShakaPlayerProps {
    manifestUrl: string;
    licenceServer: string;
    licenceCustomData: string;
    accessToken?: string;
    width?: string;
    onError?(): void;
}

export const ShakaPlayer: React.FunctionComponent<ShakaPlayerProps> = (props: ShakaPlayerProps) => {
    if (!props.licenceServer) {
        throw new Error("Shaka player requires DRM Widevine licence server to be provided");
    }
    const { error } = useNotifications();
    const videoComponentRef = useRef(null);
    const videoContainerRef = useRef(null);
    const [isError, setIsError] = useState(false);

    const handleError = (event: any) => {
        setIsError(true);

        error(`Error loading video ${JSON.stringify(event)}`);

        if (props.onError) {
            props.onError();
        }
    };

    useEffect(() => {
        const video = videoComponentRef.current;
        const videoContainer = videoContainerRef.current;

        const player = new shaka.Player(video);

        const licenceServer = `${props.licenceServer}&CustomData=${props.licenceCustomData}`;

        player.configure({
            drm: {
                servers: { "com.widevine.alpha": licenceServer }
            }
        });

        const ui = new shaka.ui.Overlay(player, videoContainer, video);
        ui.getControls();

        player.addEventListener("error", handleError);

        if (props.accessToken) {
            const cloudFrontHost = new URL(props.manifestUrl).host;
            player
                .getNetworkingEngine()
                .registerRequestFilter(
                    (_type: unknown, request: { headers: Record<string, string>; uris: string[] }) => {
                        if (request.uris[0]?.includes(cloudFrontHost)) {
                            request.headers["Authorization"] = props.accessToken as string;
                        }
                    }
                );
        }

        player.load(props.manifestUrl).then(() => {
            const textTracks = player.getTextTracks();

            if (textTracks?.length) {
                player.selectTextTrack(textTracks[0].id);
                player.setTextTrackVisibility(true);
            }
        });
    }, []);

    const containerStyle = {
        width: `${props.width || "auto"}`
    };

    const videoStyle = {
        width: "50vw",
        height: "100%",
        margin: "auto"
    };

    if (isError) {
        return <></>;
    }

    return (
        <div className="video-container" style={containerStyle} ref={videoContainerRef}>
            <video className="shaka-video" ref={videoComponentRef} style={videoStyle} />
        </div>
    );
};
